import { useParams } from "react-router-dom";
import { useSetCategoryContext } from "features/forestage/Categories/CategoryContext";
import { useEffect } from "react";
import { useForeCategoryQuery, useForeChartsQuery } from "services/api";

import Card from "features/forestage/_shared/CardStatic";
import { Helmet } from "react-helmet";
import NotFound from "features/forestage/Error";

const Detail = () => {
  const { id } = useParams();

  const { data: category, isLoading } = useForeCategoryQuery(id, {
    skip: id === undefined,
  });

  const { data: charts = [] } = useForeChartsQuery(category?.id, {
    skip: category === undefined,
  });

  const setActivatedCategory = useSetCategoryContext();

  useEffect(() => {
    if (!category) {
      return;
    }

    setActivatedCategory(category.id);
  }, [category, setActivatedCategory]);

  if (!isLoading && !category) {
    return <NotFound />;
  }

  return (
    <section>
      {category && (
        <Helmet>
          <title>{category.name} - 臺南城市儀表板</title>
          <meta
            property="og:title"
            content={`${category.name} - 臺南城市儀表板`}
          />

          <meta name="description" content="掌握城市脈動，用大數據認識臺南。" />
          <meta
            property="og:description"
            content="掌握城市脈動，用大數據認識臺南。"
          />

          <meta
            property="og:url"
            content={`https://dashboard.tainan.gov.tw/categories/${category.id}`}
          />
        </Helmet>
      )}

      <div className=" -m-4 mb-6 flex items-center justify-between bg-white p-4 md:bg-transparent">
        <h2 className="flex items-center text-[18px] md:text-2xl">
          <span className="mr-4 h-8 w-3 rounded-sm bg-grandma-300 content-['']"></span>
          {category?.name}儀表板
        </h2>

        <span className=" pr-1 text-[14px] text-base text-[#5E5E5E] md:hidden">
          共 {charts.length} 筆資料
        </span>
      </div>

      <div className="relative">
        <img
          className="pointer-events-none absolute right-0 -top-16 w-0 brightness-[100] md:w-[33%]"
          src={category?.icon}
          alt=""
        />
        <ul className="relative grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 ">
          {charts.map((item) => (
            <li key={item.id}>
              <Card
                categoryId={item.categoryId}
                dataSource={item.dataSource || item.unitName}
                id={item.id}
                name={item.boardName}
                thumbnailUrl={item.thumbnailUrl}
                url={item.url}
                viewsCount={item.viewsCount}
              ></Card>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Detail;
